import { render, staticRenderFns } from "./DispatchBag.vue?vue&type=template&id=1edb72f2"
import script from "./DispatchBag.vue?vue&type=script&lang=js"
export * from "./DispatchBag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports